import * as Sentry from "@sentry/react";

const dsn = process.env.NODE_ENV === "production" ? process.env.REACT_APP_SENTRY_DSN : null;

const environmentFromHost = (): string => {
  const host = window.location.hostname.toLowerCase();

  if (host === "localhost" || host === "127.0.0.1" || host.endsWith(".local")) {
    return "local";
  }

  if (/(^|[-.])(dev|develop|development)([-.]|$)/.test(host)) {
    return "development";
  }

  if (/(^|[-.])(stage|staging)([-.]|$)/.test(host)) {
    return "staging";
  }

  return "production";
};

const eventFrames = (event: Sentry.Event): Sentry.StackFrame[] => {
  const values = event.exception?.values || [];

  return values.reduce<Sentry.StackFrame[]>(
    (frames, value) => frames.concat(value.stacktrace?.frames || []),
    []
  );
};

// A frame either comes from the bundle this origin serves, or it was injected into the
// page by something else — an extension, a translator, a wallet.
const isOwnFrame = (frame: Sentry.StackFrame): boolean => {
  const filename = frame.filename || "";

  if (!filename || filename === "<anonymous>") {
    return false;
  }

  return filename.startsWith(window.location.origin) || filename.startsWith("/");
};

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || environmentFromHost(),
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
    ],
    denyUrls: [
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-(web-)?extension:\/\//i,
      /^chrome:\/\//i,
      /^webkit-masked-url:/i,
    ],
    // Injected scripts rewrite the dom react thinks it owns, and react then throws on a
    // node that moved under it. The stack of such a crash holds no frame of ours, which
    // is what separates it from a real bug in the panel.
    beforeSend(event) {
      const frames = eventFrames(event);

      if (frames.length && !frames.some(isOwnFrame)) {
        return null;
      }

      return event;
    },
  });
}

export {};
